import { useMemo } from 'react';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { settingsRouteLookup } from '@frontend/settings-routing';

export const useFilterSettings = (search: string) => {
  const { selectedLocationIds } = useAppScopeStore();
  const hasPhonefullAccess = hasSchemaACL(selectedLocationIds[0], Permission.PHONE_FULL_ACCESS);

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const callRouteReadFlag = getFeatureFlagValue('call-routes-settings');
  const callRouteEditFlag = getFeatureFlagValue('call-routes-settings-edit');
  const hasCallRoutesFlag = callRouteReadFlag || callRouteEditFlag;

  const filteredSettings = useMemo(() => {
    const settings = settingsRouteLookup.searchKeyword(search).map((item) => item.item);
    return settings.filter((setting) => {
      if (setting.path === '/settings/phone/call-routes/') {
        return hasCallRoutesFlag;
      }
      if (setting.path === '/settings/phone/call-recording/') {
        return hasPhonefullAccess;
      }
      return true; // Allow all other settings
    });
  }, [hasCallRoutesFlag, hasPhonefullAccess, search]);

  return filteredSettings;
};
